import { Component, Input, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { ApiResponse } from "../../models/common.model";
import { loadUser } from "../../states/user-details";
import { Store } from "@ngrx/store";
import { AppState } from "../../states/app.state";
import { CustomerService } from "../../services/customer.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { AuthServiceService } from "../../services/auth-service.service";

@Component({
    selector: 'app-verify-email-popup',
    templateUrl: './verify-email-popup.component.html',
    styleUrls: ['./verify-email-popup.component.scss']
})
export class VerifyEmailPopupComponent implements OnInit {
    @ViewChild('VerifEmailPopup') VerifEmailPopup: TemplateRef<any>;

    constructor(
        private auth: AuthServiceService,
        private toastr: ToastrService,
        private modalService: NgbModal,
        private customerService: CustomerService,
        private store: Store<AppState>,
    ) {
    }

    @Input() user: any = {};

    ngOnInit(): void {
        if (this.user?.email) {
            this.savedEmail = true;
        }
    }

    email: string = '';
    savedEmail: boolean = false;

    public openPopup() {
        this.modalService.open(this.VerifEmailPopup, {
            windowClass: 'my-modal sm verified-mail-modal',
            // backdrop: 'static',
            keyboard: false,
        });
    }


    public saveProfileInfo(): void {
        // Validate email using the pattern
        if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.email)) {
            this.toastr.error('Please enter a valid email address.');
            return;
        }

        this.auth
            .updateProfileCharacterDetails({
                email: this.email,
            })
            .subscribe(
                (resp: ApiResponse) => {
                    if (resp.message) {
                        this.store.dispatch(loadUser({}));
                        if (
                            (this.email && !this.user?.email) ||
                            this.email != this.user?.email
                        ) {
                            this.saveMemberEmail(this.email);
                        }
                        this.toastr.success(resp.message);
                    }
                },
                ({ error }) => {
                    this.toastr.error(error.message);
                }
            );
    }

    public saveMemberEmail(email) {
        this.customerService
            .saveMemberEmail({
                email: email,
            })
            .subscribe(
                (resp: ApiResponse) => {
                    if (resp.message) {
                        this.savedEmail = true;
                        this.toastr.success(resp.message);
                    }
                },
                ({ error }) => {
                    this.toastr.error(error.message);
                }
            );
    }

    selectedOTP: string = '';
    public verifyEmailOtp() {
        if (this.selectedOTP && this.selectedOTP.length == 6) {
            this.customerService
                .verifyEmailOtp({
                    otp: this.selectedOTP,
                    email: this.email,
                })
                .subscribe(
                    (resp: ApiResponse) => {
                        if (resp.message) {
                            this.toastr.success(resp.message);
                            this.modalService.dismissAll();
                            this.store.dispatch(loadUser({}));
                        }
                    },
                    ({ error }) => {
                        this.toastr.error(error.message);
                    }
                );
        } else {
            this.toastr.error('Invalid OTP!');
        }
    }
}